import { Avatar } from 'antd';
import styled, { keyframes } from 'styled-components';
import { PurpleColors } from 'theme';

const wave = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
`;

const LoadingDot = styled.span<{ $delay: number }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${PurpleColors[50]};
  opacity: 1;
  animation: ${wave} 1s infinite ease-in-out;
  animation-delay: ${(props) => props.$delay}s;
`;

const AnswerAvatar = styled(Avatar)`
  background: transparent;
  border: 1px solid ${PurpleColors[50]};
`;

export { AnswerAvatar, LoadingContainer, LoadingDot };
